export default __webpack_public_path__ + "static/media/automated-marketing-tools.83dd7a8d.png";